import { gql } from '../../__generated__/gql'

export const DELETE_COMMUNITY_COMMENT_MUTATION = gql(`
    mutation deleteCommunityComment( $id: Int! ) {
      deleteCommunityComment(input: { id: $id }) {
        clientMutationId
      }
    }
`)
